import * as React from "react"

const FbIcon = (props) => (
  <svg
    width={10}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m9.184 10.375.492-3.234h-3.13V5.03c0-.914.423-1.758 1.829-1.758h1.441V.496S8.516.25 7.286.25C4.718.25 3.03 1.832 3.03 4.645V7.14H.148v3.234h2.883v7.875h3.516v-7.875h2.637Z"
      fill="#4952E3"
    />
  </svg>
)

export default FbIcon
